<template>
  <div class="security-status" :class="statusClass">
    {{ status.description }}  
  </div>
</template>

<script>
import {computed} from 'vue'

export default {
  name: 'security-status-label',
  props: ['status'],
  setup(props) {
    const statusList = {
      1:"in-progress",
      4:'neutral',
      5:"success",
      11:"warning",
    };

    const statusClass = computed(() => {
      const status = statusList[props.status.id];
      return status || 'unknown-status';
    });

    return {
      statusClass,
    };
  },
};
</script>

<style scoped>
.security-status{
  min-width: 100px;
  font-size: 11px;
  border-radius: 4px;
  padding: 5px;
}

.neutral {
  background-color: #f0ad4e; /* Желтый */
  color: #000; /* Черный */
}

.in-progress {
  background-color:rgba(0,123,255, 0.5);
}

.partially-verified {
  background-color: #ffc107; /* Оранжевый */
  color: #000; /* Черный */
}

.success {
  background-color:rgba(145,218,85, 0.5);
  text-align: center;
}

.warning {
  background-color:rgba(220,53,69, 0.5);
}

.unknown-status {
  background-color: #888; /* Серый */
  color: #fff; /* Белый */
}
</style>
